import React, { useState, useEffect, lazy, Suspense } from 'react';
import SharedHelmet from ".././Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const BlinkingText = lazy(() => import('../../BlinkingText'));
const RelatedLinks = lazy(() => import('../RelatedLinks'));
const MainCalculatorsList = lazy(() => import('./MainCalculators'));
const TITLE = "Berapa Hari Lagi Piala Dunia 2026 - Hitung Mundur Piala Dunia";
const DESCRIPTION = "Berapa hari lagi Piala Dunia 2026? Hitung mundur Piala Dunia FIFA memberikan informasi akurat tentang kapan Piala Dunia dimulai, berapa hari lagi turnamen sepak bola terbesar di dunia, serta waktu yang tersisa hingga kompetisi dimulai. Ikuti hitung mundur Piala Dunia dan ketahui waktu yang tersisa.";
const KEYWORDS = "Piala Dunia 2026, berapa hari lagi Piala Dunia, hitung mundur Piala Dunia, kapan Piala Dunia, Piala Dunia FIFA 2026, World Cup 2026, jadwal Piala Dunia, pertandingan Piala Dunia, FIFA 2026";
const OG_URL = "https://do-calculate.com/articles-id/worldcup";
function WorldCupCountdown() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const worldCupDate = new Date("2026-06-08T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(worldCupDate));
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(worldCupDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>Berapa Hari Lagi Piala Dunia 2026</h1>
            <Suspense fallback={<div>Loading...</div>}>
                <BlinkingText text="Berapa hari lagi Piala Dunia: Diperkirakan turnamen dimulai hari Senin 8 Juni 2026 di Amerika Serikat, Kanada, dan Meksiko." />
            </Suspense>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px', textAlign: 'center' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc' }}>
                        <thead>
                            <tr>
                                <th>Hari</th>
                                <th>Jam</th>
                                <th>Menit</th>
                                <th>Detik</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{timeLeft.days}</td>
                                <td>{timeLeft.hours}</td>
                                <td>{timeLeft.minutes}</td>
                                <td>{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>Informasi tentang Piala Dunia 2026</h3>
                    <p>
                        Piala Dunia FIFA adalah acara olahraga paling populer di dunia, di mana tim-tim nasional bersaing untuk meraih gelar paling bergengsi dalam sejarah sepak bola. Piala Dunia 2026 akan sangat istimewa karena untuk pertama kalinya digelar di tiga negara berbeda: Amerika Serikat, Kanada, dan Meksiko. Para penggemar sepak bola di seluruh dunia menantikan acara ini dengan penuh semangat, karena turnamen ini akan menyaksikan partisipasi 48 tim nasional untuk pertama kalinya dalam sejarah, menjadikan persaingan semakin sengit dan besar.
                    </p>
                    <p>
                        Edisi Piala Dunia mendatang ini merupakan tonggak penting dalam sejarah turnamen, karena merupakan edisi pertama dengan ekspansi jumlah tim peserta, membuka peluang lebih besar bagi tim-tim nasional untuk berpartisipasi dan mencapai prestasi baru.
                    </p>
                    <hr />
                    <Suspense fallback={<div>Loading...</div>}>
                        <RelatedLinks />
                    </Suspense>
                </div>
                <div className="col">
                    <Suspense fallback={<div>Loading...</div>}>
                        <MainCalculatorsList />
                    </Suspense>
                </div>
            </div>
        </div>
    );
}
export default WorldCupCountdown;
